import Card from '@/components/UI/Card';
import BarGraph from '@/components/UI/Chart/BarGraph';
import AreaGrowthGraph from '@/components/UI/Chart/LineChart';
import PiChart from '@/components/UI/Chart/PiChart';
import { DeviceType, GrowthDataItem, OrderData, SalesByCategory, TopCustomers } from '@/interfaces/dashboard.interface';
import { OrderStatus } from '@/utility/helper';
import React from 'react';

interface ChartResponse {
  revenueGrowth: GrowthDataItem[] | [];
  orderStatus: OrderData[] | [];
  topCustomers: TopCustomers | null;
  deviceType: DeviceType[] | []
  salesByCategory: SalesByCategory[] | []
}

const DashboardCharts: React.FC<ChartResponse> = ({
  revenueGrowth,
  orderStatus,
  topCustomers,
  deviceType,
  salesByCategory
}) => {
  const filterValues = ['Picked up', 'In progress', 'Delayed', 'Refund in progress', 'Completed'];
  const filteredOrders = orderStatus.filter(order => !filterValues.includes(order.name as OrderStatus));
  return (
    <div
      className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-5"
      uk-scrollspy="target: > div; cls: uk-animation-slide-bottom-small; delay: 100"
    >
      <div className="card-1 shadow-1 !pb-0">
        <div className="flex justify-between items-center mb-5">
          <h3 className="text-base text-black">Order's</h3>
        </div>

        <div>
          <BarGraph data={filteredOrders} isLoading={false} />
        </div>
      </div>
      <Card >
        <div className="flex justify-between items-center mb-5">
          <h3 className="text-base text-black">Orders By Category</h3>
        </div>

        <div>
          <PiChart
            data={salesByCategory.map((item) => ({ name: item?.name, revenue: item?.count })) || []}
          />
          {/* <BarGraph data={topCustomers?.bySales.map((item) => ({ name: item.customerName, count: item.count })) || []} isLoading={false} /> */}
        </div>
      </Card>


      {topCustomers && Object.keys(topCustomers).length > 0 && (
        <>
          <div className="card-1 shadow-1 !pb-0">
            <div className="flex justify-between items-center mb-5">
              <h3 className="text-base text-black">Top Customer By Order's</h3>
            </div>

            <div>
              <BarGraph data={topCustomers?.byOrders.map((item) => ({ name: item.customerName, count: item.count })) || []} isLoading={false} />
            </div>
          </div>

          <div className="card-1 shadow-1 !pb-0">
            <div className="flex justify-between items-center mb-5">
              <h3 className="text-base text-black">Top Customer By Sales's</h3>
            </div>

            <div>
              <PiChart
                data={topCustomers?.bySales.map((item) => ({ name: item.customerName, revenue: item?.count })) || []}
              />
              {/* <BarGraph data={topCustomers?.bySales.map((item) => ({ name: item.customerName, count: item.count })) || []} isLoading={false} /> */}
            </div>
          </div>

          <Card >
            <div className="flex justify-between items-center mb-5">
              <h3 className="text-base text-black">Top Customer By Sales's</h3>
            </div>

            <div>
              <PiChart
                data={deviceType.map((item) => ({ name: item?.name, revenue: item?.count })) || []}
              />
              {/* <BarGraph data={topCustomers?.bySales.map((item) => ({ name: item.customerName, count: item.count })) || []} isLoading={false} /> */}
            </div>
          </Card>
          <Card>
            <div className="flex justify-between items-center mb-5">
              <h3 className="text-base text-black">Revenue Growth</h3>
            </div>

            <div>
              <AreaGrowthGraph data={revenueGrowth} isLoading={false} />
            </div>
          </Card>
        </>
      )
      }
    </div>
  );
};

export default DashboardCharts;
